import React from "react";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import ProfilePageHeader from "components/Headers/ProfilePageHeader.js";
import FooterDefault from "components/Footers/FooterDefault.js";

function ProfilePage() {
  const [pills, setPills] = React.useState("1");
  const [firstFocus, setFirstFocus] = React.useState(false);
  const [emailFocus, setEmailFocus] = React.useState(false);
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("profile-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);
  return (
    <>
      <div className="wrapper">
        <ProfilePageHeader />
        <div className="section">
          <Container>
            <div className="button-container">
              <Button
                className="btn-round btn-icon mr-1"
                color="default"
                href="https://www.youtube.com/channel/UCUKNaLlXyuMu1M2_VQlFJSg"
                target="_blank"
                id="tooltip871723210"
                onClick={(e) => e.preventDefault()}
                size="lg"
              >
                <i className="fab fa-youtube"></i>
              </Button>
              
              <Button
                className="btn-round btn-icon mr-1"
                color="default"
                href="https://www.linkedin.com/in/jonah-poulson-78b98a196/"
                target="_blank"
                id="tooltip871723210"
                onClick={(e) => e.preventDefault()}
                size="lg"
              >
                <i className="fab fa-linkedin"></i>
              </Button>
              
              <Button
                className="btn-round btn-icon"
                color="default"
                href="https://www.instagram.com/jonahpoulson/"
                target="_blank"
                id="tooltip259363830"
                onClick={(e) => e.preventDefault()}
                size="lg"
              >
                <i className="fab fa-instagram"></i>
              </Button>
              
            </div>
            <h3 className="title">About me</h3>
            <h5 className="description text-center">
              Hello There, and thank you for coming to this site. To just introduce myself a little bit, I am a full stack software engineer,
              United States Marine and lifelong learner
            </h5>
            <Row>
              <Col md="12">
                <h4 className="title text-center">My Portfolio</h4>
                <div className="nav-align-center">
                  <Nav
                    className="nav-pills-info nav-pills-just-icons"
                    pills
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        onClick={(e) => {
                          e.preventDefault();
                          setPills("1");
                        }}
                        className={pills === "1" ? "active" : ""}
                        role="tablist"
                        href="#pablo"
                      >
                        <i className="now-ui-icons design_image"></i>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={(e) => {
                          e.preventDefault();
                          setPills("2");
                        }}
                        className={pills === "2" ? "active" : ""}
                        role="tablist"
                        href="#pablo"
                      >
                        <i className="now-ui-icons design-2_ruler-pencil"></i>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={(e) => {
                          e.preventDefault();
                          setPills("3");
                        }}
                        className={pills === "3" ? "active" : ""}
                        role="tablist"
                        href="#pablo"
                      >
                        <i className="now-ui-icons location_world"></i>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
                <TabContent className="gallery" activeTab={"pills" + pills}>
                  <TabPane tabId="pills1">
                    <Row>
                      <Col className="ml-auto mr-auto" md="5">
                        <Card
                          className="card-background card-background-product card-raised"
                          style={{
                            backgroundImage:
                              "url(" +
                              require("assets/img/bg32.jpg").default +
                              ")",
                          }}
                        >
                          <CardBody>
                            <CardTitle tag="h2">Booz Allen Hamilton</CardTitle>
                            <p className="card-description text-white">
                              I currently work as a full stack software engineer at Booz Allen Hamilton
                            </p>
                            <Badge className="badge-neutral">Career</Badge>
                            <NavLink style={{color: "white", backgroundColor: "orange", width: "45%", margin: "auto", marginTop: "5%"}} href="https://www.linkedin.com/in/jonah-poulson-78b98a196/" target="_blank">Linkedin</NavLink>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md="5">
                        <div className="info info-horizontal">
                          <div className="icon icon-warning">
                          <i
                    aria-hidden={true}
                    className="now-ui-icons files_paper"
                  ></i>
                          </div>
                          <div className="description">
                            <h5 className="info-title">Certifications</h5>
                            <Button
                              className="btn-round btn-warning"
                              color="info"
                              href="https://www.credly.com/badges/35dff81d-8810-42ab-87a1-4b85128666af/linked_in_profile" 
                              target="_blank"
                            >
                              AWS Certified Cloud Practitioner
                            </Button>
                            <Button
                              className="btn-round btn-warning"
                              color="info"
                              href="https://www.credly.com/badges/ff14c756-0eef-49dd-a5b4-5242b127ed30?source=linked_in_profile" 
                              target="_blank"
                            >
                              AWS Certified Solutions Architect - Associate
                            </Button>
                          </div>
                        </div>
                        <div className="info info-horizontal">
                          <div className="icon icon-warning">
                            <i className="now-ui-icons business_chart-bar-32"></i>
                          </div>
                          <div className="description">
                            <h5 className="info-title">
                              Technology Stacks
                            </h5>
                            <Button
                              className="btn-round btn-warning"
                              color="info"
                              href="https://stackshare.io/jcpoulson/my-stack" 
                              target="_blank"
                            >
                              My Tech Stack
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="pills2">
                    <Row>
                      <Col className="ml-auto mr-auto" md="5">
                        <Card
                          className="card-background card-background-product card-raised"
                          style={{
                            backgroundImage:
                              "url(" +
                              require("assets/img/project8.jpg").default +
                              ")",
                          }}
                        >
                          <CardBody>
                            <CardTitle tag="h2">Personal Projects</CardTitle>
                            <p className="card-description">
                              Here are some of the personal projects that I have built on my own time that are not Booz Allen Hamilton related
                            </p>
                            <Badge className="badge-neutral">Projects</Badge>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md="5">
                        <div className="info info-horizontal">
                          <div className="icon icon-danger">
                            <i className="now-ui-icons ui-2_chat-round"></i>
                          </div>
                          <div className="description">
                            <h5 className="info-title">
                              Talk To Me In Korean (React Clone)
                            </h5>
                            <p className="description">
                              Talk To Me In Korean is a very popular online learning source for learning Korean, what i built is a clone of the website
                              that utilizes React.js
                            </p>
                            <Button color="danger" href="https://ttmik.netlify.app" target="_blank">View Project</Button>
                          </div>
                        </div>
                        <div className="info info-horizontal">
                          <div className="icon icon-danger">
                            <i className="now-ui-icons design-2_ruler-pencil"></i>
                          </div>
                          <div className="description">
                            <h5 className="info-title">Joseph O' Brien</h5>
                            <p className="description">
                              Joseph O' Brien is a singer and songwriter who is currently signed with Gotee Records. Joseph was featured on America's Got Talent
                            </p>
                            <Button color="danger" href="https://jbobrienmusic.netlify.app" target="_blank">View Project</Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="pills3">
                    <Row>
                      <Col className="ml-auto mr-auto" md="5">
                        <Card
                          className="card-background card-background-product card-raised"
                          style={{
                            backgroundImage:
                              "url(" +
                              require("assets/img/bg15.jpg").default +
                              ")",
                          }}
                        >
                          <CardBody>
                            <CardTitle tag="h2">Adventure and Learning</CardTitle>
                            <p className="card-description">
                              I believe life is story being written by someone who cares about me,
                              throughout that story there are many adventures and oppurtunities for growth
                            </p>
                            <Badge className="badge-neutral">Growth</Badge>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col md="5">
                        <div className="info info-horizontal">
                          <div className="icon icon-info">
                            <i className="fab fa-youtube"></i>
                          </div>
                          <div className="description">
                            <h5 className="info-title">Teaching and Learning</h5>
                            <p className="description">
                              Although I am not huge into the social media and everything that comes with that
                              I am a huge believer in the fact that Teaching is the best way to learn. So I have a Youtube channel
                              where I share some adventures and teach some coding
                            </p>
                            <Button color="info" href="https://www.youtube.com/channel/UCUKNaLlXyuMu1M2_VQlFJSg" target="_blank">View Youtube Channel</Button>
                          </div>
                        </div>
                        <div className="info info-horizontal">
                          <div className="icon icon-info">
                            <i className="now-ui-icons location_world"></i>
                          </div>
                          <div className="description">
                            <h5 className="info-title">Language Learner</h5>
                            <p className="description">
                              As someone who is fond of adventure and learning, I currently love language learning. I am currently learning
                              Korean and Spanish
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="contactus-2">
          <div className="map" id="contactUsMap"></div>
          <Col lg="6" md="10">
            <Card className="card-contact card-raised">
              <Form id="contact-form" method="post" role="form">
                <CardHeader className="text-center">
                  <CardTitle tag="h4">Contact Me</CardTitle>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="6">
                      <div className="info info-horizontal">
                        <div className="icon icon-info">
                          <i className="now-ui-icons tech_mobile"></i>
                        </div>
                        <div className="description">
                          <h5 className="info-title">Give me a call</h5>
                          <p>
                            (703)-909-1650 <br></br>
                            Mon - Fri, 8:00-22:00
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="info info-horizontal">
                        <div className="icon icon-info">
                          <i className="now-ui-icons ui-1_email-85"></i>
                        </div>
                        <div className="description">
                          <h5 className="info-title">send me an email</h5>
                          <p>
                            jonahpoulson@gmail.com
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-2" md="6">
                      <label>Full name</label>
                      <InputGroup
                        className={firstFocus ? "input-group-focus" : ""}
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons users_circle-08"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="First Name..."
                          type="text"
                          onFocus={() => setFirstFocus(true)}
                          onBlur={() => setFirstFocus(false)}
                        ></Input>
                      </InputGroup>
                    </Col>
                    <Col className="pl-2" md="6">
                      <label>Email address</label>
                      <InputGroup
                        className={emailFocus ? "input-group-focus" : ""}
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons ui-1_email-85"></i>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Email Here..."
                          type="text"
                          onFocus={() => setEmailFocus(true)}
                          onBlur={() => setEmailFocus(false)}
                        ></Input>
                      </InputGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <FormGroup check>
                        <Label check>
                          <Input type="checkbox"></Input>
                          <span className="form-check-sign"></span>
                          I'm not a robot
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <Button
                        className="btn-round pull-right"
                        color="info"
                        type="submit"
                      >
                        Send Message
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Form>
            </Card>
          </Col>
        </div>
        <FooterDefault />
      </div>
    </>
  );
}

export default ProfilePage;
